// extracted by mini-css-extract-plugin
module.exports = {"container":"no-results_container__-8FQf","wrapperMessage":"no-results_wrapperMessage__3hoQO","carousel":"no-results_carousel__NIDd8","item":"no-results_item__etvYT"};